<script setup lang="ts">
import DiscussionThreadChat from "@/features/discussion-threads/components/discussion-thread-chat.vue";
import DiscussionThreadEmptyState from "@/features/discussion-threads/components/discussion-thread-empty-state.vue";
import type {
  DiscussionMessage,
  DiscussionThread,
  MentionableEntity,
} from "@/types";

interface Props {
  thread: DiscussionThread | null;
  messages: DiscussionMessage[];
  mentionables: MentionableEntity[];
  chatVariant?: "desktop" | "mobile";
  threadSectionClass: string;
  emptyStateClass: string;
  showAction?: boolean;
}

withDefaults(defineProps<Props>(), {
  chatVariant: "desktop",
  showAction: false,
});

const emit = defineEmits<(e: "action") => void>();
</script>

<template>
  <section
    v-if="thread"
    :class="threadSectionClass"
  >
    <DiscussionThreadChat
      :variant="chatVariant"
      embedded
      :show-header="false"
      :thread="thread"
      :messages="messages"
      :mentionables="mentionables"
    />
  </section>

  <DiscussionThreadEmptyState
    v-else
    :container-class="emptyStateClass"
    :show-action="showAction"
    @action="emit('action')"
  />
</template>
